import { createContext, useContext, useEffect, useState } from 'react';
import { getAllTableData } from '../services/recentTransactions';
import { DateFormats, formatDate } from '../utils/utils';
import { AuthStore } from './auth';

const date = new Date();

export type TransactionHistoryState = {
  recentTransactions: [];
};

export const TransactionHistoryStore = createContext<TransactionHistoryState>({
  recentTransactions: [],
});

const { Provider } = TransactionHistoryStore;

export const TransactionHistoryProvider = ({ children }: any) => {
  const [, , , selectedPersona] = useContext(AuthStore) || [];
  const [transactionHistoryState, setTransactionHistoryState] =
    useState<TransactionHistoryState>({
      recentTransactions: [],
    });

  useEffect(() => {
    let count = 0;
    let recentTransactions = getAllTableData(selectedPersona).map((x: any) => {
      count += 5;

      return {
        ...x,
        requestedDate: formatDate(
          new Date(date.getFullYear(), date.getMonth(), date.getDate() - count),
          DateFormats.US
        ),
      };
    });

    setTransactionHistoryState({
      recentTransactions,
    });
  }, [selectedPersona]);

  return <Provider value={transactionHistoryState}>{children}</Provider>;
};
